import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationInsuranceLiability: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={356}
        height={228}
      >
        <path d="M0 0h356v228H0V0Z" fill="#C0C2C9" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160Z"
          fill={colors.primary[50]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 226a2 2 0 0 1 2-2h310a2 2 0 1 1 0 4H22a2 2 0 0 1-2-2Z"
          fill={colors.primary[500]}
        />
        <path
          d="m102.482 93.096 3.242-9.186c.884-2.504 3.918-3.468 6.085-1.932l9.508 6.739a4 4 0 0 1 .73 5.86l-5.752 6.739a4 4 0 0 1-5.134.814l-6.998-4.293a4 4 0 0 1-1.681-4.74ZM141.738 72.465l12.902-8.286a4 4 0 0 1 5.523 1.197l5.903 9.15a4 4 0 0 1-1.036 5.424l-9.717 6.94a3.999 3.999 0 0 1-4.93-.22l-9.089-7.804c-2.032-1.745-1.809-4.954.444-6.4ZM228.886 148.535l9.355-14.477c1.537-2.378 4.992-2.45 6.626-.137l4.351 6.156a4.004 4.004 0 0 1 .51 3.626l-3.332 9.551a4 4 0 0 1-4.248 2.655l-10.374-1.231c-2.939-.349-4.495-3.658-2.888-6.143ZM192.197 141.543l4.791-5.497c1.724-1.979 4.855-1.789 6.327.384l5.469 8.073a4 4 0 0 1-1.093 5.572l-5.626 3.751a4 4 0 0 1-5.446-.965l-4.633-6.326a4.002 4.002 0 0 1 .211-4.992ZM158.323 147.157l2.25-12.374c.626-3.443 5.06-4.479 7.147-1.668l9.172 12.354a4.001 4.001 0 0 1-.152 4.961l-3.867 4.591a4 4 0 0 1-5.131.846l-7.555-4.573a4 4 0 0 1-1.864-4.137ZM135.015 109.562l7.244-1.156c3.066-.489 5.496 2.548 4.346 5.432l-7.123 17.858c-.972 2.438-3.989 3.294-6.098 1.731l-7.744-5.744a3.999 3.999 0 0 1-.901-5.497l7.623-10.959a3.997 3.997 0 0 1 2.653-1.665ZM180.609 96.147h15.945a4 4 0 0 1 3.19 1.586l6.854 9.057a4 4 0 0 1 .483 3.997l-2.143 4.973a4.002 4.002 0 0 1-4.068 2.398l-12.25-1.213a3.997 3.997 0 0 1-2.95-1.787l-8.406-12.818c-1.744-2.66.164-6.194 3.345-6.194ZM186.979 174.132l13.121-8.14a4.002 4.002 0 0 1 3.167-.459l14.465 3.968a4 4 0 0 1 2.941 3.858v8.041a4 4 0 0 1-3.201 3.92l-21.631 4.406a4.001 4.001 0 0 1-4.046-1.583l-5.954-8.276a4 4 0 0 1 1.138-5.735ZM96 153.386V193a4 4 0 0 0 4 4h52.723c2.649 0 4.566-2.53 3.851-5.081l-1.87-6.668a4.001 4.001 0 0 0-2.68-2.744l-6.107-1.872a4.001 4.001 0 0 1-2.749-3.033l-2.816-13.952a4.002 4.002 0 0 0-2.446-2.927l-5.951-2.359a4 4 0 0 1-2.371-2.62l-1.508-5.277a4 4 0 0 0-5.651-2.47l-9.448 4.775a3.998 3.998 0 0 1-3.276.15l-8.23-3.256c-2.625-1.038-5.471.897-5.471 3.72ZM260.455 110.99l-.868-59.049a4.001 4.001 0 0 0-4-3.941h-61.941a4 4 0 0 0-3.966 4.524l1.453 10.994a4 4 0 0 0 2.575 3.227l13.691 5.075a4 4 0 0 1 2.398 5.034l-1.065 3.144a4 4 0 0 0 2.362 5.02l3.791 1.448a4 4 0 0 1 2.435 2.693l2.107 7.795a3.999 3.999 0 0 0 3.57 2.946l12.469.909a4.007 4.007 0 0 1 1.715.529l9.379 5.437a4.005 4.005 0 0 1 1.883 2.522l.29 1.202a3.998 3.998 0 0 0 2.441 2.791l3.834 1.488c2.645 1.026 5.489-.951 5.447-3.788Z"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m243.817 56.108 8.616 8.447M234.526 57.122l14.866 14.866M108.501 170.984l15.204 15.036M105.629 178.586l8.109 8.109"
          stroke={colors.primary[500]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default IllustrationInsuranceLiability;
